import React from "react";
import styled from "styled-components";
import { Colors } from "../../assets/Res/Colors";

const PrimaryButtonWrapper = styled.div`
  justify-content: center;
  border-radius: 50px;
  cursor: pointer;
  width: ${(props) => (props.width ? props.width : "100%")};
  background-color: ${(props) => (props.bgColor ? props.bgColor : Colors.RED)};

  @media (max-width: 1400px) {
    width: ${(props) => (props.smallWidth ? props.smallWidth : props.width)};
  }
`;

const Text = styled.p`
  font-family: Helvetica;
  color: ${(props) => (props.color ? props.color : "black")};
  text-align: center;
  padding: ${(props) => (props.padding ? props.padding : "")};
`;

export const PrimaryButton = ({
  color,
  bgColor,
  width,
  text,
  onClick,
  padding,
  smallWidth,
}) => {
  return (
    <>
      <PrimaryButtonWrapper
        bgColor={bgColor}
        width={width}
        onClick={onClick}
        smallWidth={smallWidth}
      >
        <Text color={color} padding={padding}>
          {text}
        </Text>
      </PrimaryButtonWrapper>
    </>
  );
};
